import { CleanerLoginForm } from '@/features/cleaner/login-form';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/(cleaner)/_auth-layout/cleaner/login')({
  component: CleanerLoginForm,
});
